import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  inputs: [{
    internalType: "address",
    name: "controller_",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "newCaller",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "newValue",
    type: "bool"
  }],
  name: "CallerUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "newController",
    type: "address"
  }],
  name: "ControllerUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "stakingContract",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }],
  name: "NewStakingContractOwner",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "_stakingContract",
    type: "address"
  }, {
    internalType: "address",
    name: "_owner",
    type: "address"
  }, {
    internalType: "address",
    name: "_previousOwner",
    type: "address"
  }],
  name: "assignOwnerToContract",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "authorisedCallers",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "contractCountPerOwner",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "contractToOwner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "contractsCount",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "controller",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "getContracts",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "address[]",
    name: "",
    type: "address[]"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "getContractsCount",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address[]",
    name: "_array",
    type: "address[]"
  }, {
    internalType: "address",
    name: "value",
    type: "address"
  }],
  name: "getIndexArray",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "indexToContract",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "ownerToContracts",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_caller",
    type: "address"
  }, {
    internalType: "bool",
    name: "_value",
    type: "bool"
  }],
  name: "setCaller",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_newController",
    type: "address"
  }],
  name: "setController",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
var StakingRegistry__factory = /** @class */function () {
  function StakingRegistry__factory() {}
  StakingRegistry__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  StakingRegistry__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  StakingRegistry__factory.abi = _abi;
  return StakingRegistry__factory;
}();

export { StakingRegistry__factory };
